import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from "./app/store";

import App from "./App";

import "./index.css";

import { LanguageProvider } from "./contexts/languageContext";

ReactDOM.render(
  <Provider store={store}>
    <LanguageProvider>
      <App />
    </LanguageProvider>
  </Provider>,

  document.getElementById("root")
);
